"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactRedux = require("react-redux");
var _style = _interopRequireDefault(require("./style.css"));
var _flag = _interopRequireDefault(require("cccisd-icons/flag5"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up5"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ProgressBar = /*#__PURE__*/function (_React$Component) {
  function ProgressBar() {
    _classCallCheck(this, ProgressBar);
    return _callSuper(this, ProgressBar, arguments);
  }
  _inherits(ProgressBar, _React$Component);
  return _createClass(ProgressBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        progressBar = _this$props.progressBar,
        useFlex = _this$props.useFlex;

      // RETURN - do not display if less than 2 elements
      if (progressBar.length < 2) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
      }
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: (0, _classnames["default"])(_style["default"].barWrapper, 'progress', useFlex ? _style["default"].flex : _style["default"].fixed)
      }, (0, _map2["default"])(progressBar, function (step, i) {
        var statusStyle = '';
        switch (step.status) {
          case 'not_started':
            statusStyle = _style["default"].notStarted;
            break;
          case 'started':
            statusStyle = 'progress-bar-striped ' + _style["default"].started;
            break;
          case 'completed':
            statusStyle = 'progress-bar-info';
            break;
          default:
            break;
        }
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: i,
          className: (0, _classnames["default"])(statusStyle, 'progress-bar')
        }, step.isCurrent && /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].current
        }, /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null)), step.isMilestone && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_flag["default"], null)));
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(ProgressBar, "propTypes", {
  useFlex: _propTypes["default"].bool,
  // From redux
  progressBar: _propTypes["default"].array
});
_defineProperty(ProgressBar, "defaultProps", {
  useFlex: false
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    progressBar: state.assignment.player.progressBar
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(ProgressBar);